import React from 'react'
import ModalContent from './modal_content'
import FlatButton from '../buttons/flat_button'

interface DeleteConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  itemName: string
  isDeleting?: boolean
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  isDeleting = false,
}) => {
  if (!isOpen) return null

  // モーダルの背景をクリックしたら閉じる
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && !isDeleting) {
      onClose()
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <ModalContent
          title="削除確認"
          onClose={isDeleting ? undefined : onClose}
          className="w-full max-w-md"
        >
          <div className="p-6">
            <div className="mb-6">
              <p className="font-bold mb-2">{itemName}</p>
              <p className="mb-4">上記を削除してもよろしいですか？</p>
              <p className="text-sm text-main-darkgray">
                この操作は取り消せません。
              </p>
            </div>

            <div className="flex gap-3 justify-center">
              <FlatButton
                onClick={onClose}
                disabled={isDeleting}
                outline
                type="button"
              >
                キャンセル
              </FlatButton>
              <FlatButton
                onClick={onConfirm}
                disabled={isDeleting}
                type="button"
                className="bg-main-red text-white"
              >
                {isDeleting ? '削除中...' : '削除する'}
              </FlatButton>
            </div>
          </div>
        </ModalContent>
      </div>
    </div>
  )
}

export default DeleteConfirmModal
